export const SERIE_DESCRIPTION_SCHEMA = {
  fields: [
    { name: 'Langue', type: 'string', indexed: true },
    { name: 'Algorithm', type: 'string', indexed: true },
    { name: 'Version', type: 'string', indexed: true },
    { name: 'Certification', type: 'string', indexed: true },
    { name: 'Result', type: 'string', indexed: true },
    { name: 'ImageType', type: 'string', indexed: true },
    { name: 'Doute', type: 'string', indexed: true },
    { name: 'Positive pathologies', type: 'string', indexed: true },
    { name: 'AgeCategory', type: 'string', indexed: true },
    { name: 'Option', type: 'string', indexed: true },
  ],
};

/**
 * @function parseSerieDescription
 * @description Parse a series description based on the SERIE_DESCRIPTION_SCHEMA
 * @param {string} serieDescription The series description to parse
 * @returns {object} The parsed series description
 */
export const parseSerieDescription = serieDescription => {
  const values = serieDescription.split('|');
  const parsed = {};
  SERIE_DESCRIPTION_SCHEMA.fields.forEach((field, index) => {
    const value = values[index] ? values[index].trim() : null;
    if (field.type === 'number') {
      parsed[field.name] = value ? parseFloat(value) : null;
    } else {
      parsed[field.name] = value || null;
    }
  });

  return parsed;
};
